module.exports = __webpack_public_path__ + "static/img/6.4bff418.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/6.svg
// module id = 1clE
// module chunks = 0